import React from 'react';

const TitleSession = ({items}) => {
    return (
        <div className='list__need'>
           <ol className='iransans-b'>
            <li> <span>{items.section_1}</span></li>
            <li> <span>{items.section_2}</span></li>
            <li> <span>{items.section_3}</span></li>
            </ol> 
           <ol start={4} className='iransans-b'>
           <li> <span>{items.section_4}</span></li>
            <li> <span>{items.section_5}</span></li>
            <li> <span>{items.section_6}</span></li>
            </ol> 
           <ol start={7} className='iransans-b'>
           <li> <span>{items.section_7}</span></li>
            <li> <span>{items.section_8}</span></li>
            <li> <span>{items.section_9}</span></li>
            </ol> 
        </div>
    );
};

export default TitleSession;